import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { Platform } from '@unimodules/core';
import { Asset } from 'expo-asset';
import ExponentAV from "./ExponentAV";
export var PitchCorrectionQuality;

(function (PitchCorrectionQuality) {
  PitchCorrectionQuality[PitchCorrectionQuality["Low"] = ExponentAV && ExponentAV.Qualities && ExponentAV.Qualities.Low] = "Low";
  PitchCorrectionQuality[PitchCorrectionQuality["Medium"] = ExponentAV && ExponentAV.Qualities && ExponentAV.Qualities.Medium] = "Medium";
  PitchCorrectionQuality[PitchCorrectionQuality["High"] = ExponentAV && ExponentAV.Qualities && ExponentAV.Qualities.High] = "High";
})(PitchCorrectionQuality || (PitchCorrectionQuality = {}));

export var _DEFAULT_PROGRESS_UPDATE_INTERVAL_MILLIS = 500;
export var _DEFAULT_INITIAL_PLAYBACK_STATUS = {
  positionMillis: 0,
  progressUpdateIntervalMillis: _DEFAULT_PROGRESS_UPDATE_INTERVAL_MILLIS,
  shouldPlay: false,
  rate: 1.0,
  shouldCorrectPitch: false,
  volume: 1.0,
  isMuted: false,
  isLooping: false
};
export function getNativeSourceFromSource(source) {
  var uri = null;
  var overridingExtension = null;
  var headers;

  if (typeof source === 'string' && Platform.OS === 'web') {
    return {
      uri: source,
      overridingExtension: overridingExtension,
      headers: headers
    };
  }

  var asset = _getAssetFromPlaybackSource(source);

  if (asset != null) {
    uri = asset.localUri || asset.uri;
  } else if (source != null && typeof source !== 'number' && 'uri' in source && typeof source.uri === 'string') {
    uri = source.uri;
  }

  if (uri == null) {
    return null;
  }

  if (source != null && typeof source !== 'number' && 'overrideFileExtensionAndroid' in source && typeof source.overrideFileExtensionAndroid === 'string') {
    overridingExtension = source.overrideFileExtensionAndroid;
  }

  if (source != null && typeof source !== 'number' && 'headers' in source && typeof source.headers === 'object') {
    headers = source.headers;
  }

  return {
    uri: uri,
    overridingExtension: overridingExtension,
    headers: headers
  };
}

function _getAssetFromPlaybackSource(source) {
  if (source == null) {
    return null;
  }

  var asset = null;

  if (typeof source === 'number') {
    asset = Asset.fromModule(source);
  } else if (source instanceof Asset) {
    asset = source;
  }

  return asset;
}

export function assertStatusValuesInBounds(status) {
  if (typeof status.rate === 'number' && (status.rate < 0 || status.rate > 32)) {
    throw new RangeError('Rate value must be between 0.0 and 32.0');
  }

  if (typeof status.volume === 'number' && (status.volume < 0 || status.volume > 1)) {
    throw new RangeError('Volume value must be between 0.0 and 1.0');
  }
}
export function getNativeSourceAndFullInitialStatusForLoadAsync(source, initialStatus, downloadFirst) {
  var fullInitialStatus, asset, nativeSource;
  return _regeneratorRuntime.async(function getNativeSourceAndFullInitialStatusForLoadAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          fullInitialStatus = initialStatus == null ? _DEFAULT_INITIAL_PLAYBACK_STATUS : _objectSpread(_objectSpread({}, _DEFAULT_INITIAL_PLAYBACK_STATUS), initialStatus);
          assertStatusValuesInBounds(fullInitialStatus);

          if (!(typeof source === 'string' && Platform.OS === 'web')) {
            _context.next = 4;
            break;
          }

          return _context.abrupt("return", {
            nativeSource: {
              uri: source,
              overridingExtension: null
            },
            fullInitialStatus: fullInitialStatus
          });

        case 4:
          asset = _getAssetFromPlaybackSource(source);

          if (!(downloadFirst && asset)) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return _regeneratorRuntime.awrap(asset.downloadAsync());

        case 8:
          nativeSource = getNativeSourceFromSource(source);

          if (!(nativeSource === null)) {
            _context.next = 11;
            break;
          }

          throw new Error("Cannot load an AV asset from a null playback source");

        case 11:
          return _context.abrupt("return", {
            nativeSource: nativeSource,
            fullInitialStatus: fullInitialStatus
          });

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function getUnloadedStatus() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return _objectSpread({
    isLoaded: false
  }, error ? {
    error: error
  } : null);
}
export var PlaybackMixin = {
  playAsync: function playAsync() {
    return _regeneratorRuntime.async(function playAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", this.setStatusAsync({
              shouldPlay: true
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, null, this, null, Promise);
  },
  playFromPositionAsync: function playFromPositionAsync(positionMillis) {
    var tolerances,
        _args3 = arguments;
    return _regeneratorRuntime.async(function playFromPositionAsync$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            tolerances = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            return _context3.abrupt("return", this.setStatusAsync({
              positionMillis: positionMillis,
              shouldPlay: true,
              seekMillisToleranceAfter: tolerances.toleranceMillisAfter,
              seekMillisToleranceBefore: tolerances.toleranceMillisBefore
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, null, this, null, Promise);
  },
  pauseAsync: function pauseAsync() {
    return _regeneratorRuntime.async(function pauseAsync$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", this.setStatusAsync({
              shouldPlay: false
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, null, this, null, Promise);
  },
  stopAsync: function stopAsync() {
    return _regeneratorRuntime.async(function stopAsync$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", this.setStatusAsync({
              positionMillis: 0,
              shouldPlay: false
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setPositionAsync: function setPositionAsync(positionMillis) {
    var tolerances,
        _args6 = arguments;
    return _regeneratorRuntime.async(function setPositionAsync$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            tolerances = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            return _context6.abrupt("return", this.setStatusAsync({
              positionMillis: positionMillis,
              seekMillisToleranceAfter: tolerances.toleranceMillisAfter,
              seekMillisToleranceBefore: tolerances.toleranceMillisBefore
            }));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setRateAsync: function setRateAsync(rate) {
    var shouldCorrectPitch,
        pitchCorrectionQuality,
        _args7 = arguments;
    return _regeneratorRuntime.async(function setRateAsync$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            shouldCorrectPitch = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
            pitchCorrectionQuality = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : PitchCorrectionQuality.Low;
            return _context7.abrupt("return", this.setStatusAsync({
              rate: rate,
              shouldCorrectPitch: shouldCorrectPitch,
              pitchCorrectionQuality: pitchCorrectionQuality
            }));

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setVolumeAsync: function setVolumeAsync(volume) {
    return _regeneratorRuntime.async(function setVolumeAsync$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", this.setStatusAsync({
              volume: volume
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setIsMutedAsync: function setIsMutedAsync(isMuted) {
    return _regeneratorRuntime.async(function setIsMutedAsync$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", this.setStatusAsync({
              isMuted: isMuted
            }));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setIsLoopingAsync: function setIsLoopingAsync(isLooping) {
    return _regeneratorRuntime.async(function setIsLoopingAsync$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", this.setStatusAsync({
              isLooping: isLooping
            }));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, null, this, null, Promise);
  },
  setProgressUpdateIntervalAsync: function setProgressUpdateIntervalAsync(progressUpdateIntervalMillis) {
    return _regeneratorRuntime.async(function setProgressUpdateIntervalAsync$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", this.setStatusAsync({
              progressUpdateIntervalMillis: progressUpdateIntervalMillis
            }));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, null, this, null, Promise);
  }
};